import { Card } from "flowbite-react";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState,useMemo } from "react";

export const PaymentState = () => {
	const state = useParams().state;
	const redirect_url = useParams().redirect_url;
	const decoded_url = useMemo(() => atob(redirect_url), [redirect_url]);
	const navigate = useNavigate();

	const [countdown, setCountdown] = useState(5);
	useEffect(() => {
		const intervalId = setInterval(() => {
			setCountdown((prevCount) => prevCount - 1);
		}, 1000);

		return () => clearInterval(intervalId);
	}, []);

	setTimeout(() => {
		navigate("/" + decoded_url);
	}, 5000);

	return (
		<div className="flex space-y-6 justify-center">
			<Card>
				{state === "success" ? (
					<p>Your Payment was successful</p>
				) : (
					<p>Your Payment was cancelled</p>
				)}
				<div>Redirecting in {countdown} seconds</div>
			</Card>
		</div>
	);
};
